import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { ORGANISATION_ROLE_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const OrganisationRoleService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_ROLE_RESOURCE,
      method: 'get',
      request: (tag, rejectCallback, t) => ({
        url: apiRoutes.organisationRoles(tag),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getOrganisationRoleFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default OrganisationRoleService;
